module.exports = __webpack_public_path__ + "static/media/meroha-app-icon-transition.7826d19a.png";